import React from 'react';
import FilterList from '../../../components/user/code/codeFilterList';
import Layout from '../../../components/layouts/verticalLayout';

const CodeListPage = (props) => {
  return <Layout body={<FilterList />} />;
};

CodeListPage.propTypes = {};

export default CodeListPage;
